import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ee4fe40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "font-weight": "800",
    "font-size": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left fontCoarse"
}, "时间", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "胜"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "平"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "负"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_6 = {
  class: "left fontCoarse"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "u-batNum"
};
const _hoisted_9 = {
  key: 0,
  class: "u-img"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  key: 1,
  class: "u-img"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  key: 2,
  class: "u-img"
};
const _hoisted_16 = {
  class: "content"
};
const _hoisted_17 = {
  class: "u-batNum"
};
const _hoisted_18 = {
  key: 0,
  class: "u-img"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = {
  key: 1,
  class: "u-img"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_23 = [_hoisted_22];
const _hoisted_24 = {
  key: 2,
  class: "u-img"
};
const _hoisted_25 = {
  class: "content"
};
const _hoisted_26 = {
  class: "u-batNum"
};
const _hoisted_27 = {
  key: 0,
  class: "u-img"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_29 = [_hoisted_28];
const _hoisted_30 = {
  key: 1,
  class: "u-img"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  key: 2,
  class: "u-img"
};
import { h, ref } from 'vue';
export default {
  __name: 'HadList',
  setup(__props, {
    expose: __expose
  }) {
    const hadList = ref([]);
    const firstOption = ref('无');
    const secondOption = ref('无');
    const pushHadList = list => {
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let s = list[i].updateDate.split('-');
          list[i].date = s[1] + '-' + s[2];
        }
      }
      hadList.value = list;
      let hL = [];
      let dL = [];
      let aL = [];
      for (let i = 0; i < list.length; i++) {
        hL[i] = parseFloat(list[i].h);
        dL[i] = parseFloat(list[i].d);
        aL[i] = parseFloat(list[i].a);
      }
      let hLS = computeDiscrepancy(hL);
      let dLS = computeDiscrepancy(dL);
      let aLs = computeDiscrepancy(aL);
      let numbers = [hLS, dLS, aLs];
      numbers = numbers.slice().sort((a, b) => a - b);
      if (list.length > 1) {
        if (numbers[0] == hLS) {
          firstOption.value = '胜';
        } else if (numbers[0] == dLS) {
          firstOption.value = '平';
        } else {
          firstOption.value = '负';
        }
        if (numbers[1] == hLS) {
          secondOption.value = '胜';
        } else if (numbers[1] == dLS) {
          secondOption.value = '平';
        } else {
          secondOption.value = '负';
        }
      }
    };
    const probabilities = array => {
      let list = [];
      for (let i = 0; i < array.length; i++) {
        let hadSum = 0;
        let hadList = [];
        for (let j = 0; j < array[i].length; j++) {
          hadSum = count(hadSum, count(1, array[i][j], '/'), '+');
        }
        let hadRate = count(100, hadSum, '/');
        for (let j = 0; j < array[i].length; j++) {
          hadList[j] = count(hadRate, array[i][j], '/');
        }
        list[i] = hadList;
      }
      return list;
    };
    const computeDiscrepancy = array => {
      if (!Array.isArray(array) || array.length === 0) {
        return 0;
      }
      const mean = array.reduce((sum, value) => sum + value, 0) / array.length;
      return array.reduce((discrepancy, value) => {
        return discrepancy + Math.abs(value - mean);
      }, 0);
    };
    const count = (num1, num2, symbol) => {
      let str1 = num1.toString();
      let str2 = num2.toString();
      let result, len1, len2, step;
      try {
        len1 = str1.split('.')[1].length;
      } catch (e) {
        len1 = 0;
      }
      ;
      try {
        len2 = str2.split('.')[1].length;
      } catch (e) {
        len2 = 0;
      }
      ;
      step = Math.pow(10, Math.max(len1, len2));
      let a = parseInt(num1 * step);
      let b = parseInt(num2 * step);
      switch (symbol) {
        case '+':
          result = (a + b) / step;
          break;
        case "-":
          result = (a - b) / step;
          break;
        case "*":
          result = a * b / step / step;
          break;
        case "/":
          result = a / b;
          break;
        default:
          break;
      }
      return result;
    };

    // 暴露给外部使用的函数
    __expose({
      pushHadList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("胜平负")]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, "胜平负 推荐 首选：" + _toDisplayString(firstOption.value) + " 次选：" + _toDisplayString(secondOption.value), 1), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hadList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 9
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(change.date) + " " + _toDisplayString(change.updateTime), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(change.h), 1), change.hf == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11)) : change.hf == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14)) : (_openBlock(), _createElementBlock("span", _hoisted_15))])]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(change.d), 1), change.df == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20)) : change.df == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_23)) : (_openBlock(), _createElementBlock("span", _hoisted_24))])]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(change.a), 1), change.af == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_29)) : change.af == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_30, _hoisted_32)) : (_openBlock(), _createElementBlock("span", _hoisted_33))])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))], 64);
    };
  }
};